module.exports = "/packs/media/images/life_expectancy-56517eeebcf0a4b4ae0720db7b6241ca.png";